export default "__VITE_ASSET__CMgYn2rK__"